module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x1@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x1@2x.png
// module id = 81
// module chunks = 3